import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Vue from 'vue'
import moment from 'moment/moment'

@Module({
  namespaced: true
})
export default class Calendars extends VuexModule {
  calendarsLoaded = false
  calendars: KwixeoCalendars.Calendars = []
  headerEventsLoaded = false;
  headerEvents: KwixeoCalendars.Events = []
  totalHeaderEvents = 0
  maxHeaderEvent = 5

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['Calendars', 'HeaderEvents']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
    this.context.commit('setTotalHeaderEvents', 0)
  }

  @Mutation
  setCalendarsLoaded (state = true): void {
    this.calendarsLoaded = state
  }

  get calendar (): (calendarId: number) => KwixeoCalendars.Calendar|undefined {
    return (calendarId: number) => {
      return this.calendars.find(calendar => calendar.id === calendarId)
    }
  }

  @Mutation
  setCalendars (calendars: KwixeoCalendars.Calendars): void {
    this.calendars = calendars
  }

  @Mutation
  mutateAddCalendar (calendar: KwixeoCalendars.Calendar): void {
    const index = this.calendars.findIndex(el => el.id === calendar.id)
    if (index === -1) {
      this.calendars.push(calendar)
    }
  }

  @Mutation
  mutateUpdateCalendar (calendar: KwixeoCalendars.Calendar): void {
    const idx = this.calendars.findIndex(c => c.id === calendar.id)
    if (idx >= 0) {
      Vue.set(this.calendars, idx, calendar)
    } else {
      this.calendars.push(calendar)
    }
  }

  @Mutation
  mutateDeleteCalendar (calendar: KwixeoCalendars.Calendar): void {
    const idx = this.calendars.findIndex(c => c.id === calendar.id)
    if (idx >= 0) {
      this.calendars.splice(idx, 1)
      this.headerEvents = this.headerEvents.filter(event => event.calendar_id !== calendar.id)
    }
  }

  @Action
  async loadCalendars (force = false): Promise<void> {
    if (!this.calendarsLoaded || force) {
      const response = await Vue.prototype.$kwCalendars.axios.get('/calendar?per_page=500&include=team_user')
      await this.context.commit('setCalendars', response.data.data)
      this.context.commit('setCalendarsLoaded')
    }
  }

  @Action
  addCalendar (calendar: KwixeoCalendars.Calendar): void {
    this.context.commit('mutateAddCalendar', calendar)
  }

  @Action
  updateCalendar (calendar: KwixeoCalendars.Calendar): void {
    this.context.commit('mutateUpdateCalendar', calendar)
  }

  @Action
  deleteCalendar (calendar: KwixeoCalendars.Calendar): void {
    this.context.commit('mutateDeleteCalendar', calendar)
  }


  // Change the loaded state
  @Mutation
  setHeaderEventsLoaded (state = true): void {
    this.headerEventsLoaded = state
  }

  // Order the events
  @Mutation
  orderEvents (): void {
    this.headerEvents = this.headerEvents.sort(function(a,b){
      return new Date(a.begin).getTime() - new Date(b.begin).getTime();
    });
  }

  // Set the header events
  @Mutation
  setHeaderEvents (events: KwixeoCalendars.Events): void {
    this.headerEvents = events
  }

  // Set the header events
  @Mutation
  setTotalHeaderEvents (total: number): void {
    this.totalHeaderEvents = total
  }

  // Add or update a header event
  @Mutation
  updateHeaderEvent (event: KwixeoCalendars.Event): void {
    if (!this.headerEventsLoaded) {
      return
    }
    const index = this.headerEvents.findIndex(val => val.id === event.id)
    if (index >= 0) {
      Vue.set(this.headerEvents, index, event)
    } else {
      this.headerEvents.push(event)
      this.totalHeaderEvents++
    }
  }

  // Remove a header event
  @Mutation
  removeHeaderEvent (event: KwixeoCalendars.Event): void {
    if (!this.headerEventsLoaded) {
      return
    }
    const index = this.headerEvents.findIndex(val => val.id === event.id)
    if (index >= 0) {
      Vue.delete(this.headerEvents, index)
      this.totalHeaderEvents--
    }
  }

  // Load the header event from the server
  @Action
  async loadHeaderEvents (force = false): Promise<void> {
    if (!this.headerEventsLoaded || force) {
      const response = await Vue.prototype.$kwCalendars.axios.get('/calendar/event', {
        params: {
          per_page: this.maxHeaderEvent,
          filter: {
            begin: moment().format('YYYY-MM-DD'),
            end: moment().add(this.context.rootGetters['user/teamUserConfigs'].calendar_header_limit, 'days').format('YYYY-MM-DD')
          }
        }
      })
      await this.context.commit('setHeaderEvents', response.data.data)
      this.context.commit('setTotalHeaderEvents', response.data.meta.total)
      this.context.commit('setHeaderEventsLoaded')
      this.context.commit('orderEvents')
    }
  }

  // Add or update a header event
  @Action
  setHeaderEvent (event: KwixeoCalendars.Event): void {
    this.context.commit('updateHeaderEvent', event)
    if (this.headerEventsLoaded) {
      this.context.commit('orderEvents')
    }
  }

  // Delete a header event
  @Action
  deleteHeaderEvent (event: KwixeoCalendars.Event): void {
    this.context.commit('removeHeaderEvent', event)
  }
}
